import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiZoningCertificateConstants } from "../../constants/api-constants/api-zoning-certificate.constants";
let ZoningCertificateService = class ZoningCertificateService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiZoningCertificateConstants.URL}/${applicationId}/${ApiZoningCertificateConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ZoningCertificateService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ZoningCertificateService);
export { ZoningCertificateService };
